import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { isFranchiseTenant } from "../../../utils/franchise/franchiseAbsenteeismMenu";
import { INDEX } from "../../../constants/routes";

type Props = {
  children: React.ReactNode;
};

/** Bloquea Cuenta Corriente para tenants de franquicia. */
export function FranchiseCuentaCorrienteRouteGuard({ children }: Props) {
  const franchiseState = useSelector((state: RootState) => state.franchise);
  if (isFranchiseTenant(franchiseState)) {
    return <Navigate to={INDEX} replace />;
  }
  return <>{children}</>;
}
